import { Component, OnInit, inject } from '@angular/core';
import { AuditEventSearchRequestDto, AuditLogFilterComponent, AuditLogTableComponent, getEnterpriseLabels, GroupSearchService, SecurityDomain } from 'lib';
import { catchError, map, of, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { EnterpriseLabelsFetchService } from '../../services/enterprise-labels-fetch.service';

@Component({
    selector: 'mmoga-audit-logs',
    imports: [
        AuditLogFilterComponent,
        AuditLogTableComponent
    ],
    standalone: true,
    templateUrl: './audit-logs.component.html',
    styleUrl: './audit-logs.component.scss'
})
export class AuditLogsComponent implements OnInit {
    private readonly groupSearchService = inject(GroupSearchService);
    private readonly toastrService = inject(ToastrService);
    private readonly enterpriseLabelsFetchService = inject(EnterpriseLabelsFetchService);

    private ENTERPRISES_NO = 500;

    auditLogFilterSubject = new Subject<AuditEventSearchRequestDto>;
    enterpriseLabels = getEnterpriseLabels(SecurityDomain.MODMED);
    enterpriseMap: Map<number, string> = new Map<number, string>();

    ngOnInit(): void {
        this.enterpriseLabelsFetchService.getEnterpriseLabels().then(
            labels => this.enterpriseLabels = labels
        );
        this.groupSearchService.getGroups('', 0, this.ENTERPRISES_NO, 'name', 'ASC')
            .pipe(
                map(response => {
                    this.enterpriseMap = new Map(
                        response.content.filter(ent => ent.id !== null)
                            .map(ent => [ent.id!, ent.name])
                    );
                }),
                catchError(() => {
                    this.toastrService.error('Failed to retrieve enterprises.');
                    return of([]);
                })
            ).subscribe();
    }

    handleFilterChange(searchRequest: AuditEventSearchRequestDto): void {
        this.auditLogFilterSubject.next(searchRequest);
    }
}
